// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const LegendElement = styled.div`
  display: flex;
  align-items: center;
`;

const LegendIcon = styled.div`
  width: 24px;
  margin-right: ${({ theme }) => (theme.metrics.margin)}px;
  border-top: 1px solid ${({ color }) => color};
`;

const LegendLabel = styled.span`
  font-size: ${({ theme }) => (theme.fonts.style.midSmall.fontSize)}px;
  margin-right:  ${({ theme }) => (theme.metrics.margin)}px;
  color: ${({ color }) => color};
`;

type Props = {
  payload: any;

  t: any;
  theme: any;
};

function HistoryGraphLegend({ payload, t, theme }: Props) {
  function getLineColor(dataKey: string) {
    return dataKey === 'reach' ? theme.colors.reach : theme.colors.listeningTime;
  }

  return (
    <LegendContainer>
      <LegendElement key={payload[0].value}>
        <LegendIcon color={getLineColor(payload[0].value)} />
        <LegendLabel color={getLineColor(payload[0].value)}>{t(payload[0].value)}</LegendLabel>
      </LegendElement>
      <LegendElement key={payload[1].value}>
        <LegendIcon color={getLineColor(payload[1].value)} />
        <LegendLabel color={getLineColor(payload[1].value)}>{t(payload[1].value)}</LegendLabel>
      </LegendElement>
    </LegendContainer>
  );
}

export default withTheme(translate()(HistoryGraphLegend));



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/components/HistoryGraphLegend.js